var _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAu = function SvgAu(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_21787_20749",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#4171CF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_21787_20749)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#1C3A9A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -2.5,
    y: -2.5,
    width: 16.6667,
    height: 12.5,
    fill: "#1C3A9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8346 -2.08333L9.16797 2.5L-1.66536 10H-5.83203L12.5013 -2.5L15.8346 -2.08333Z",
    fill: "#F6F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5.83203 -1.24935L-0.832031 2.91732L10.8346 10.0007H14.168V9.16732L-2.91536 -1.66602L-5.83203 -1.24935Z",
    fill: "#F6F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.33203 6.66602L13.7487 9.99935H14.1654V9.58268L9.58203 6.66602H8.33203Z",
    fill: "#BD2E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4.16797 0L1.2487 3.33333H1.66536V2.91667L-2.91797 0H-4.16797Z",
    fill: "#BD2E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.41797 2.91732L12.0846 -1.66602L12.5013 -1.24935L5.83464 3.33398L5.41797 2.91732Z",
    fill: "#BD2E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.33203 10L3.33464 5.41667H4.16797L-2.4987 10H-3.33203Z",
    fill: "#BD2E33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.91797,
    y: -1.66602,
    width: 2.5,
    height: 11.6667,
    fill: "#F6F8FA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.168,
    y: 2.91602,
    width: 3.33333,
    height: 16.6667,
    transform: "rotate(90 14.168 2.91602)",
    fill: "#F6F8FA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.168,
    y: 3.54102,
    width: 2.08333,
    height: 16.6667,
    transform: "rotate(90 14.168 3.54102)",
    fill: "#BD2E33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.33203,
    y: -1.66602,
    width: 1.66667,
    height: 11.6667,
    fill: "#BD2E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8333 12L17.9714 12.5466L18.4849 12.3138L18.1437 12.7625L18.6458 13.0188L18.0822 13.0318L18.1949 13.5841L17.8333 13.1516L17.4718 13.5841L17.5845 13.0318L17.0209 13.0188L17.523 12.7625L17.1818 12.3138L17.6952 12.5466L17.8333 12Z",
    fill: "#F6F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 8L15.9714 8.54655L16.4849 8.31376L16.1437 8.7625L16.6458 9.01877L16.0822 9.03179L16.1949 9.58414L15.8333 9.15164L15.4718 9.58414L15.5845 9.03179L15.0209 9.01877L15.523 8.7625L15.1818 8.31376L15.6952 8.54655L15.8333 8Z",
    fill: "#F6F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8333 6L17.9714 6.54655L18.4849 6.31376L18.1437 6.7625L18.6458 7.01877L18.0822 7.03179L18.1949 7.58414L17.8333 7.15164L17.4718 7.58414L17.5845 7.03179L17.0209 7.01877L17.523 6.7625L17.1818 6.31376L17.6952 6.54655L17.8333 6Z",
    fill: "#F6F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.85925 15.6212L7.12057 14.753L6.39703 15.6339L6.61526 14.515L5.47545 14.4986L6.48626 13.9716L5.78848 13.0702L6.83071 13.5319L7.1004 12.4243L7.38923 13.5271L8.42332 13.0474L7.74125 13.9607L8.76104 14.4701L7.62168 14.5063L7.85925 15.6212Z",
    fill: "#F6F8FA"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAu);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/au.29009e23afb39fd1d866290cd4a0d6ce.svg";